import React, { useEffect, useState } from 'react'
import { SurveyAnswersView } from '../../views'
import { useParams } from 'react-router-dom'
import { LocalStorageService, SurveyService } from '../../../services'

const SurveyAnswersAction = () => {
    const url = process.env.REACT_APP_ETICKET_API
    const localStorageService = new LocalStorageService()
    const surveyService = new SurveyService(url)
    const { surveyId } = useParams()

    const [data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    const downloadCSV = async () => {
        const token = localStorageService.getLocalStorageItem('token').accessToken
        const csvData = await surveyService.downloadSurveyAnswers(surveyId, token)
        const fileName = data.title.replace(/[^a-zA-Z0-9._-]/g, '');

        const url = window.URL.createObjectURL(new Blob([csvData]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `answers-${fileName}.csv`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }

    const getData = async () => {
        setIsLoading(true)
        const token = localStorageService.getLocalStorageItem('token').accessToken
        const answers = await surveyService.getSurveyAnswers(surveyId, token)
        setData(answers)
        setIsLoading(false)
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <SurveyAnswersView
            isLoading={isLoading}
            data={data}
            downloadCSV={downloadCSV}
        />
    )
}

export default SurveyAnswersAction